module.exports = __webpack_public_path__ + "img/logo.e359e435.svg";